module.exports = __webpack_public_path__ + "img/condominium-icon.svg";